// sub collection slider in collection page
window.addEventListener("load", (event) => {
  var mySwiper_subcollection = new Swiper(".mySwiper_subcollection", {
    slidesPerView: 8.9,
    centeredSlides: false,
    spaceBetween: 40,
    grabCursor: true,
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
      700: {
        slidesPerView: 5.5,
        spaceBetween: 40,
      },
      1000: {
        slidesPerView: 7.5,
        spaceBetween: 40,
      },
      1200: {
        slidesPerView: 7.5,
        spaceBetween: 40,
      },
      1366: {
        slidesPerView: 7.5,
        spaceBetween: 40,
      },
      1400: {
        slidesPerView: 7.5,
        spaceBetween: 40,
      },
      1950: {
        slidesPerView: 13,
        spaceBetween: 40,
      },
      2200: {
        slidesPerView: 13,
        spaceBetween: 40,
      },
    },
  });
});

//Swiper featured collection
window.addEventListener("load", (event) => {
  var collectionswiper = new Swiper(".collectionswiper", {
    slidesPerView: 4.5,
    spaceBetween: 30,
    freeMode: true,
    direction: "horizontal",
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1.5,
        spaceBetween: 20,
      },
      374: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 3.5,
        spaceBetween: 10,
      },
      1365: {
        slidesPerView: 4.5,
        spaceBetween: 10,
      },
      2200: {
        slidesPerView: 6.5,
        spaceBetween: 32,
      },
    },
    on: {
      init: () => {
        //dispatch custom event
        const customEvent = new CustomEvent("filter:sections_loaded");
        document.dispatchEvent(customEvent);
      },
    },
  });
});

//product page greetings enable
function enableGreetingCardInputs() {
  document
    .querySelectorAll("#greeting_card_properties_wrap input")
    .forEach((input) => input.removeAttribute("disabled"));
  document.querySelector("#main_product_bundle_id").removeAttribute("disabled");
}

function hasActiveUpsellProduct() {
  return Array.from(document.querySelectorAll("upsell-product")).some(
    (product) => product.classList.contains("active")
  );
}

function highlightEmptyFields(fields, borderStyle) {
  fields.forEach((field) => {
    if (field.value.trim() === "") {
      field.style.border = borderStyle;
    }
  });
}

function show1() {
  const cardMessageInput = document.getElementById("card_message_input");
  document.getElementById("div1").style.display = "none";
  document.getElementById("message-warning").style.display = "none";

  cardMessageInput.value = "No Card Selected";
  if (!hasActiveUpsellProduct()) {
    document
      .querySelectorAll("#greeting_card_properties_wrap input")
      .forEach((input) => input.setAttribute("disabled", "disabled"));
    document
      .querySelector("#main_product_bundle_id")
      .setAttribute("disabled", "disabled");
  } else {
    document
      .querySelectorAll("#greeting_card_properties_wrap input")
      .forEach((input) => input.setAttribute("disabled", "disabled"));
  }
}

function show2() {
  const cardMessageInput = document.getElementById("card_message_input");
  const giftMessage = document.getElementById("message");
  const recipientName = document.getElementById("receiver-name");
  const senderName = document.getElementById("sender-name");
  const messageWarning = document.getElementById("message-warning");
  const div1 = document.getElementById("div1");

  cardMessageInput.value = "";
  div1.classList.remove("hide");
  div1.style.display = "block";

  if (giftMessage.value.trim() === "") {
    const customBorder = "2px solid #fe9903";
    messageWarning.style.display = "flex";
    giftMessage.style.border = customBorder;
    highlightEmptyFields([recipientName, senderName], customBorder);
  }
  enableGreetingCardInputs();

}

// function show1() {
//   document.getElementById("card_message_input").value = "No Card Selected";
//   const messageWarning = document.getElementById("message-warning");
//   document.getElementById("div1").style.display = "none";
//   messageWarning.style.display = "none";

//   const upsellProducts = document.querySelectorAll("upsell-product");
//   let hasActiveClass = false;
//   upsellProducts.forEach((product) => {
//     if (product.classList.contains("active")) {
//       hasActiveClass = true;
//     }
//   });

//   if (!hasActiveClass) {
//     document
//       .querySelectorAll("#greeting_card_properties_wrap input")
//       .forEach((input_field) => {
//         input_field.setAttribute("disabled", "disabled");
//       });

//     document
//       .querySelector("#main_product_bundle_id")
//       .setAttribute("disabled", "disabled");
//   } else {
//     // document
//     //   .querySelectorAll("#greeting_card_properties_wrap input")
//     //   .forEach((input_field) => {
//     //     if (input_field.id === "greeting_card_message") {
//     //       input_field.setAttribute("disabled", "disabled");
//     //     }
//     //   });
//     document
//       .querySelectorAll("#greeting_card_properties_wrap input")
//       .forEach((input_field) => {
//         input_field.setAttribute("disabled", "disabled");
//       });
//   }

//   // document.getElementById('greeting_card_properties_wrap').innerHTML = '';
// }

// function show2() {
//   document.getElementById("card_message_input").value = "";
//   const occasion = document.querySelector(
//     ".select2-container--default .select2-selection--single"
//   );
//   //const occasionValue = document.getElementById("occasion").value;
//   const giftMessage = document.getElementById("message");
//   const recipientName = document.getElementById("receiver-name");
//   const senderName = document.getElementById("sender-name");
//   const messageWarning = document.getElementById("message-warning");
//   document.getElementById("div1").classList.remove("hide");
//   document.getElementById("div1").style.display = "block";
//   if (
//     giftMessage.value.trim() === "" &&
//     document.getElementById("div1").style.display === "block"
//   ) {
//     const customBorder = "2px solid #fe9903";
//     messageWarning.style.display = "flex";
//     //occasionValue === "" && (occasion.style.border = customBorder);
//     giftMessage.style.border = customBorder;
//     recipientName.value === "" && (recipientName.style.border = customBorder);
//     senderName.value === "" && (senderName.style.border = customBorder);
//   }
//   // var now = document.querySelector('#bundle_properties_wrap').getAttribute('now');
//   // var greetings_card_product_var_id = document.querySelector('#greeting_card_properties_wrap').getAttribute('greetings_card_product_var_id');
//   // document.querySelector('#greeting_card_properties_wrap').innerHTML += `<input disabled type="hidden" name="items[][id]" value="${greetings_card_product_var_id}" class="product-upsell-id">`;
//   // document.querySelector('#greeting_card_properties_wrap').innerHTML += `<input disabled type="hidden" name="items[][properties][Message Card]" value="" id="greeting_card_properties" class="product-upsell-id properties_${greetings_card_product_var_id}">`;
//   // document.querySelector('#greeting_card_properties_wrap').innerHTML += `<input disabled type="hidden" name="items[][properties][Message_bundle_ID]" value="${now}">`;
// }

{
  /* <input type="hidden" disabled="" name="items[][id]" value="43133268459699" class="product-upsell-id">
</input><input type="hidden" disabled="" name="items[][properties][Message Card]" value="" id="greeting_card_properties" class="product-upsell-id">
<input type="hidden" disabled="" id="greeting_card_properties" name="items[][properties][Message_bundle_ID]" value="1710148545">  */
}
function changeMessageIdea() {
  var messageSelect = document.getElementById("message-ideas");
  var selectedMessageIdeas =
    messageSelect.options[messageSelect.selectedIndex].value;
  var messageElement = document.getElementById("message");
  var messageWarning = document.getElementById("message-warning");
  var receiverName = document.getElementById("receiver-name").value;
  var senderName = document.getElementById("sender-name").value;

  // if (messageElement.value.trim() !== "") {
  messageWarning.style.display = "none";
  document.getElementById("message").style.border = "";
  // }
  if (receiverName.trim() === "") {
    document.getElementById("receiver-name").style.border = "";
  }

  if (senderName.trim() === "") {
    document.getElementById("sender-name").style.border = "";
  }

  if (selectedMessageIdeas) {
    messageElement.value = selectedMessageIdeas;
    document.querySelector(
      "#greeting_card_properties_wrap #greeting_card_message"
    ).value = selectedMessageIdeas;
  }
  //Style select
  const selectIdeas = document.getElementById("message-ideas");
  if (selectIdeas.value === "") {
    selectIdeas.classList.add("grey-select");
  } else {
    selectIdeas.classList.remove("grey-select");
  }
}
function changeOccasion() {
  var occasion = document.getElementById("occasion").value;
  var messageSelect = document.getElementById("message-ideas");
  var messageElement = document.getElementById("message").value;

  if (occasion.trim() !== "") {
    document.querySelector(
      ".select2-container--default .select2-selection--single"
    ).style.border = "";
  }

  var giftMessages = document
    .getElementById("giftMessages")
    .dataset.messages.split("::");

  var splitOccasion = occasion && occasion.split("_");
  var selectedOccasionCode = splitOccasion && splitOccasion[0].trim();
  var selectedOccasionName = splitOccasion && splitOccasion[1].trim();
  // var combinedValue = `${salutationText} ${receiverName}`;
  messageSelect.innerHTML =
    '<option value="" selected>Click for Gift Message Ideas</option>';

  giftMessages.forEach(function (message) {
    var parts = message.split("_");
    var occasionCode = parts[0].trim();
    var messageText = parts[1];

    if (selectedOccasionCode === occasionCode) {
      var newOption = document.createElement("option");
      newOption.value = messageText;
      newOption.textContent = messageText;
      messageSelect.appendChild(newOption);
    }
  });
  if (selectedOccasionName || messageElement) {
    document.querySelector(
      "#greeting_card_properties_wrap #greeting_card_occasion"
    ).value = selectedOccasionName;
    messageElement &&
      (document.querySelector(
        "#greeting_card_properties_wrap #greeting_card_message"
      ).value = messageElement);
    document
      .querySelectorAll("#greeting_card_properties_wrap input")
      .forEach((input_field) => {
        input_field.removeAttribute("disabled");
      });
    document
      .querySelector("#main_product_bundle_id")
      .removeAttribute("disabled");
  } else {
    document.querySelector(
      "#greeting_card_properties_wrap #greeting_card_occasion"
    ).value = selectedOccasionName;
    document
      .querySelectorAll("#greeting_card_properties_wrap input")
      .forEach((input_field) => {
        input_field.setAttribute("disabled", "disabled");
      });
    document
      .querySelector("#main_product_bundle_id")
      .setAttribute("disabled", "disabled");
  }
  //Style select
  const selectOccasion = document.getElementById("occasion");
  const selectIdeas = document.getElementById("message-ideas");
  if (selectOccasion.value === "") {
    selectOccasion.classList.add("grey-select");
    selectIdeas.classList.add("grey-select");
  } else {
    selectOccasion.classList.remove("grey-select");
    selectIdeas.classList.remove("grey-select");
  }
}
function textAreaChanged() {
  // var text = document.getElementById("greeting-card").value;
  // var salutationText = document.getElementById("salutation").value;
  var receiverName = document.getElementById("receiver-name").value;
  var messageEl = document.getElementById("message").value;
  var closingText = document.getElementById("closing").value;
  var senderName = document.getElementById("sender-name").value;
  var messageWarning = document.getElementById("message-warning");
  var occasion = document.getElementById("occasion").value;

  if (messageEl.trim() !== "") {
    document.getElementById("message").style.border = "";
  }
  
  if (receiverName) {
    document.getElementById("receiver-name").style.border = "";
  }

  if (senderName) {
    document.getElementById("sender-name").style.border = "";
  }
  if (
    messageEl.trim() !== "" &&
    receiverName.trim() !== "" &&
    senderName.trim() !== ""
  ) {
    messageWarning.style.display = "none";
  } 

  if (occasion || messageEl) {
    document.querySelector(
      ".select2-container--default .select2-selection--single"
    ).style.border = "";
  }

  if (receiverName || messageEl || closingText || senderName) {
    // document.querySelector(
    //   "#greeting_card_properties_wrap #greeting_card_properties"
    // ).value = text;

    // salutationText &&
    //   (document.querySelector(
    //     "#greeting_card_properties_wrap #greeting_card_salutation"
    //   ).value = salutationText);
    receiverName &&
      (document.querySelector(
        "#greeting_card_properties_wrap #greeting_card_receiver"
      ).value = receiverName);
    messageEl &&
      (document.querySelector(
        "#greeting_card_properties_wrap #greeting_card_message"
      ).value = messageEl);
      (document.querySelector(
        "#greeting_card_properties_wrap #greeting_card_closing"
      ).value = closingText);
    senderName &&
      (document.querySelector(
        "#greeting_card_properties_wrap #greeting_card_sender"
      ).value = senderName);

    document
      .querySelectorAll("#greeting_card_properties_wrap input")
      .forEach((input_field) => {
        input_field.removeAttribute("disabled");
      });

    document
      .querySelector("#main_product_bundle_id")
      .removeAttribute("disabled");
  } else {
    // document.querySelector(
    //   "#greeting_card_properties_wrap #greeting_card_properties"
    // ).value = text;

    // document.querySelector(
    //   "#greeting_card_properties_wrap #greeting_card_salutation"
    // ).value = salutationText;
    // document.querySelector(
    //   "#greeting_card_properties_wrap #greeting_card_occasion"
    // ).value = selectedOccasionName;
    document.querySelector(
      "#greeting_card_properties_wrap #greeting_card_receiver"
    ).value = receiverName;
    document.querySelector(
      "#greeting_card_properties_wrap #greeting_card_message"
    ).value = messageEl;
    document.querySelector(
      "#greeting_card_properties_wrap #greeting_card_closing"
    ).value = closingText;
    document.querySelector(
      "#greeting_card_properties_wrap #greeting_card_sender"
    ).value = senderName;

    document
      .querySelectorAll("#greeting_card_properties_wrap input")
      .forEach((input_field) => {
        input_field.setAttribute("disabled", "disabled");
      });

    document
      .querySelector("#main_product_bundle_id")
      .setAttribute("disabled", "disabled");
  }
}

//Read more

function readMore(ele, eve) {
  eve.preventDefault();
  var txt = document.querySelector(".read_more_text");
  txt.classList.toggle("collection-hero__description");

  if (txt.classList.contains("collection-hero__description")) {
    ele.innerText = "Read More";
  } else {
    ele.innerText = "Read Less";
  }
}

///scroll bar
// document.addEventListener("load", (event) => {
var mySwiper_filter_scroll = new Swiper(".mySwiper_filter_scrolll", {
  direction: "vertical",
  slidesPerView: "auto",
  freeMode: true,
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: false,
  },
  mousewheel: true,
});
// });

// collection filter open & close

function openupsell_qty(param) {
  //  console.log(param.previousElementSibling.previousElementSibling.previousElementSibling);
  //  console.log(param.closest("upsell-product"));
  // if (param.closest("upsell-product").classList.contains("active")) {
  // }else{
  //     param.previousElementSibling.previousElementSibling.previousElementSibling.click();
  // }
  // param.nextElementSibling.classList.toggle("hide");
}

document.addEventListener("filter:sections_loaded", () => {
  if (document.querySelector("#product-grid") != null) {
    let productGrid = document.querySelector("#product-grid").childElementCount;
    if (document.querySelector(".max-product-count")) {
      let productCountElement = document.querySelector(".max-product-count");
      productCountElement.innerHTML = productGrid;
    }
  }
});

var swiperCategory = new Swiper(".categories-slider", {
  slidesPerView: 2.5,
  spaceBetween: 10,
  //pagination: {
  //   el: ".swiper-pagination",
  //   clickable: true,
  // },
  navigation: {
    nextEl: ".swiper-button-next-category",
    prevEl: ".swiper-button-prev-category",
  },
  animating: true,
  breakpoints: {
    350: {
      slidesPerView: 2.5,
      spaceBetween: 14,
    },
    640: {
      slidesPerView: 2.5,
      spaceBetween: 14,
    },
    767: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    1365: {
      slidesPerView: 3,
      spaceBetween: 12,
    },
    2200: {
      slidesPerView: 4,
      spaceBetween: 12,
    },
  },
});

var swiper_mySwiper_all_products = new Swiper(".mySwiper_all_products", {
  slidesPerView: 2.5,
  spaceBetween: 10,
  //pagination: {
  //   el: ".swiper-pagination",
  //   clickable: true,
  // },
  navigation: {
    nextEl: ".swiper-button-next-allproduct",
    prevEl: ".swiper-button-prev-allproduct",
  },
  animating: true,
  breakpoints: {
    350: {
      slidesPerView: 2.5,
      spaceBetween: 14,
    },
    640: {
      slidesPerView: 2.5,
      spaceBetween: 14,
    },
    767: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    1365: {
      slidesPerView: 3,
      spaceBetween: 12,
    },
    2200: {
      slidesPerView: 4,
      spaceBetween: 12,
    },
  },
});